module.exports = __webpack_public_path__ + "static/media/category-menu-2.50406b98.webp";